/**
 * Returns true if tokens are available and the used tokens are less than the available tokens.
 *
 * Special case to allow unlimited actions: availableTokens is null or undefined. -> Returns true.
 */
export const advancedAiTokensAvailable = (usedTokens, availableTokens) => {
    if (!availableTokens) return true;

    // In case the tokens have been set as a string, convert them to integers. This way we make sure it always works.
    return parseInt(usedTokens) < parseInt(availableTokens);
}